import { connect } from 'react-redux';
import mapProfileToProps from 'profile/containers/map_profile_to_props';
import Projects from 'profile/components/projects';

export default connect(mapProfileToProps)(Projects);



// WEBPACK FOOTER //
// ./profile/containers/projects.js